/** Copies aventurier retirées : elles réutilisaient les calques 2D de Lyra. */
export const RETIRED_LYRA_DERIVED_ADVENTURER_IDS = new Set([
  'receptionist_red_hair_f', 'receptionist_black_hair_f',
  'steampunk_hair_f', 'steampunk_hair_face_f', 'hair_ears_f',
  'receptionist_barrette_f', 'village_barrette_f', 'steampunk_barrette_f',
  'hair_flower_f', 'receptionist_glasses_f', 'steampunk_goggles_f',
  'receptionist_top_f', 'village_top_f', 'steampunk_vest_f', 'fairy_dress_f',
  'necklace_f', 'steampunk_necklace_f', 'receptionist_necklace_f',
  'receptionist_pants_f', 'village_pants_f', 'steampunk_pants_f',
  'receptionist_shoes_f', 'village_shoes_f', 'steampunk_boots_f',
  'fairy_shoes_f', 'clipboard_f', 'clipboard_baked_f', 'steampunk_slate_f',
  'steampunk_wings_f', 'fairy_wings_f',
]);

/** Pièces Lyra masquées le temps de corriger leurs calques 2D. */
export const TEMPORARILY_HIDDEN_LYRA_ITEM_IDS = new Set([
  'quest_clipboard',
  'steampunk_slate',
  'steampunk_hair_face',
  'receptionist_barrette',
]);

// Source de vérité de la garde-robe portée par Lyra à la création.
export const LYRA_STARTER_OUTFIT: Record<string, string | null> = {
  wings: null,
  dress: 'village_top',
  pants: 'village_pants',
  hair: 'receptionist_red_hair',
  shoes: 'village_shoes',
  necklace: null,
  hairFlower: 'white_flower',
  glasses: 'receptionist_glasses',
  heldItem: null,
};

export const LYRA_STARTER_ITEMS: string[] =
  Object.values(LYRA_STARTER_OUTFIT).filter((id): id is string => !!id);
